import AssignAdvisorDropdownContainer from './AssignAdvisorDropdownContainer';

export default AssignAdvisorDropdownContainer;
